import { JackingForce } from "../../pages/JackingForce";

export function MobileJackingForce() {
  return <JackingForce />;
}
